<template>
<div
  class="totalprice"
  v-loading="showBookActionLoader">
  <template v-if="requestBooking && object.ibeData.price > 0">
    <div>
      <span v-if="mediaquery > 2">
        {{ $t('ibe.total') }}
      </span>
      <span v-if="appControl.showBQTotalPrice"
        class="price-bq"
        style="font-size:26px;">
        {{ object.ibeData.price | currencyFormat(object.ibeData.currency) }}
      </span>
      <span v-else
        class="price-bq"
        style="font-size:26px;">
        {{ $t('ibe.onRequest') }}
      </span>
    </div>
    <div v-if="mediaquery > 2"
      class="price-bq">
      <i
        class="el-icon-warning">
      </i>
      {{ $t('ibe.text_price_bq') }}
    </div>
  </template>
  <template v-else-if="object.ibeData.price > 0">
    <div>
      <span v-if="mediaquery > 2">
        {{ $t('ibe.total') }}
      </span>
      <span
        class="price-b"
        style="font-size:26px;">
        {{ object.ibeData.price | currencyFormat(object.ibeData.currency) }}
      </span>
    </div>
    <div v-if="mediaquery > 2"
      class="price-b">
      <i
        class="el-icon-success">
      </i>
      {{ $t('ibe.text_price_b') }}
    </div>
  </template>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ListServices',
  data () {
    return {
      bNotifyShowed: false,
      bqNotifyShowed: false,
      breakPointXS: 380,
      breakPointSM: 580
    }
  },
  computed: {
    ...mapGetters('booking', [
      'appControl',
      'object',
      'showBookActionLoader',
      'requestBooking',
      'mediaquery'
    ])
  },
  watch: {
    showBookActionLoader () {
      if (this.mediaquery <= 2) {
        if (!this.bqNotifyShowed && this.requestBooking && this.object.ibeData.price > 0) {
          this.bqNotifyShowed = true
          this.$notify.warning({
            title: this.$t('ibe.headline_info_bq'),
            message: this.$t('ibe.text_info_bq'),
            duration: this.appControl.timeouts.bookTypeNotify
          })
        }
        if (!this.bNotifyShowed && !this.requestBooking && this.object.ibeData.price > 0) {
          this.bNotifyShowed = true
          this.$notify.success({
            title: this.$t('ibe.headline_info_b'),
            message: this.$t('ibe.text_info_b'),
            duration: this.appControl.timeouts.bookTypeNotify
          })
        }
      }
    }
  }
}
</script>
